import { createContext as t } from "react";
const o = t({ strict: !1 });
export {
  o as LazyContext
};
